import styled from 'styled-components'

export const ResumeContainer = styled.div`
    height: 850px;
    width: 100%;
    overflow-y: auto;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
`